export {};

$(init);

NLMK.initSelects = init;

const $win = $(window);

$win.on('initSelects', init);
$win.on('init.initSelects', init);

function init() {
    const $selectBoxesTemplates = $('template').find('.select-box');
    const $selectBoxes = $('.select-box')
        .not($selectBoxesTemplates)
        .not('.select-box-init');

    if ($selectBoxes.length) {
        require.ensure(
            ['./init'],
            function() {
                const { default: eachBox } = require('./init');

                $selectBoxes.each(eachBox);
            },
            'select',
        );
    }
}



// WEBPACK FOOTER //
// ./js/main/module/select/index.js